module.exports = __webpack_public_path__ + "static/media/solvemoji-junior-logo.f71181b5.svg";